import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { QualityCertificateRepository } from "@entity/data/repositories/quality-certificate.repository";
import { inject, injectable } from "inversify";

@injectable()
export class DeleteQualityCertificateUseCase {
    constructor(
        @inject(QualityCertificateRepository)
        private readonly qualityCertificateRepository: QualityCertificateRepository,
    ) {}

    async execute(qualityCertificateId: number): Promise<void> {
        const result =
            await this.qualityCertificateRepository.delete(
                qualityCertificateId,
            );

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
        }

        ToastManagerStore.success();
    }
}
